export default __webpack_public_path__ + "static/media/ao.f9ff6391.jpg";